import { VigilanceAlertsResponse } from "../Api/VigilanceSante/Dto/VigilanceAlertsResponse";

class VigilanceAlertsData {
    public numberOfAlerts?: number;
    public severeAlertLevel?: number;
    public eventId?: string;
    public vigilanceLastDatabaseUpdateDate: Date | null;

    public static fromResponseModel(vigilanceAlertsResponse: VigilanceAlertsResponse): VigilanceAlertsData {
        if (!vigilanceAlertsResponse)
            return null;

        return {
            numberOfAlerts: vigilanceAlertsResponse.NumberOfAlerts,
            severeAlertLevel: vigilanceAlertsResponse.SevereAlertLevel,
            eventId: vigilanceAlertsResponse.EventId,
            vigilanceLastDatabaseUpdateDate: vigilanceAlertsResponse.VigilanceLastDatabaseUpdateDate
        };
    }
}

export { VigilanceAlertsData };
